import React from 'react';
import { InvestorResource } from '../../common/entities';
import { Badge, Button, Col, Row } from 'react-bootstrap';
import { isArray } from 'lodash';
import { Link } from 'react-router-dom';

/**
 * @description Properties to be passed to this component.
 * @interface
 */
interface Props {
  investor: InvestorResource;
}

/**
 * @description Investor search result component.
 * @param {Props} props
 * @return {JSX.Element}
 */
const InvestorSearchResult = (props: Props): JSX.Element => {
  const investor = props.investor.attributes;
  const subtitle = [];
  if (investor.city) {
    subtitle.push(investor.city);
  }
  if (investor.country) {
    subtitle.push(investor.country);
  }
  return (
    <article>
      <Row>
        <Col xs={12} className="d-flex justify-content-between">
          <div className="d-flex justify-content-between">
            <img
              width="64"
              height="64"
              style={{
                maxWidth: '64px',
                maxHeight: '64px',
                marginRight: '1rem',
              }}
              className="img-thumbnail"
              src={`https://briefed.in/assets/img/investors/${investor.id}.png`}
              onError={({ currentTarget }) => {
                currentTarget.onerror = null;
                currentTarget.src = '/assets/img/email-newsletter-1px.png';
              }}
              alt={investor.investorName}
            />
            <div>
              <h2 className="mb-n1">{investor.investorName}</h2>
              <p>{subtitle.join(' | ')}</p>
            </div>
          </div>

          <div>
            <Button href={`/investor.html?${investor.id}`} rel="noreferrer">
              More Info{' '}
              <span className="material-icons-outlined text-sm align-middle">
                arrow_circle_right
              </span>
            </Button>
          </div>
        </Col>
      </Row>
      <Row>
        <Col xs={12}>
          {investor.description ? <p>{investor.description}</p> : null}
          <span className="">
            <Badge bg={'light'} style={{ marginRight: '1rem' }}>
              Deals: {investor.numDeals}
            </Badge>
          </span>
          {isArray(investor.sectors) ? (
            <React.Fragment>
              <span>
                {investor.sectors.map((tag) => (
                  <Link
                    key={tag}
                    to={{
                      pathname: '/',
                      search: `?q=&a=tags|${tag}`,
                    }}
                  >
                    <Badge bg={'light'} style={{ marginRight: '1rem' }}>
                      {tag}
                    </Badge>
                  </Link>
                ))}
              </span>
            </React.Fragment>
          ) : null}
          {isArray(investor.stages) ? (
            <React.Fragment>
              <span>
                {investor.stages.map((tag) => (
                  <Link
                    key={tag}
                    to={{
                      pathname: '/',
                      search: `?q=&a=tags|${tag}`,
                    }}
                  >
                    <Badge bg={'light'} style={{ marginRight: '1rem' }}>
                      {tag}
                    </Badge>
                  </Link>
                ))}
              </span>
            </React.Fragment>
          ) : null}
          {investor.website ? (
            <span className="">
              <a
                href={investor.website}
                target="_blank"
                className="text-primary text-sm"
                rel="briefed.in noreferrer"
              >
                Website&nbsp;
                <span className="material-icons-outlined text-sm text-primary align-middle">
                  launch
                </span>
              </a>
            </span>
          ) : null}
        </Col>
      </Row>
      <hr />
    </article>
  );
};

export default InvestorSearchResult;
